import { lazy } from 'react';
import { Route, Routes } from "react-router-dom";

const AboutUs = lazy(() => import('../aboutUs'));
const PlantNursery = lazy(() => import('../plantNursery'));
const Projects = lazy(() => import('../projects'));
const GardenCare = lazy(() => import('../gardenCare'));
const Contact = lazy(() => import('../contact'));
const NoMatch = lazy(() => import('../noMatch'));

const BodyRouter = () => {
  return (
    <div>
        <Routes>
          <Route path="/" element={<AboutUs />} />
          <Route path="/plantNursery" element={<PlantNursery />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/gardenCare" element={<GardenCare />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
    </div>
  );
};

export default BodyRouter;
